var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"object-cover flex-shrink-0",class:[_vm.width,_vm.height,_vm.borderRadius, _vm.margin],attrs:{"src":_vm.gravatarSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }